module.exports = __webpack_public_path__ + "static/img/RU.03ef720.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/RU.png
// module id = 6sm/
// module chunks = 1